
const pagos = {
    AltaPagos: 'SIVAC/Administracion/Caja/AltaPagos',
    GetUltimoFolio: 'SIVAC/Administracion/Caja/GetUltimoFolio',
    GetFoliosSinImprimir: 'SIVAC/Administracion/Caja/GetFoliosSinImprimir'
}

const firmas = {

    AltaFirmas: 'SIVAC/Administracion/Firmas/AltaFirmas',
    EdicionEstatusFirma: 'SIVAC/Administracion/Firmas/EdicionEstatusFirma',
    DarDeBajaProcesado: 'SIVAC/Administracion/Firmas/DarDeBajaProcesado',
    EdicionProcesado: 'SIVAC/Administracion/Firmas/EdicionProcesado',
    EdicionProcesadoTemporalidad: 'SIVAC/Administracion/Firmas/EdicionProcesadoTemporalidad',
    AltaNuevoExpedienteProcesado: 'SIVAC/Administracion/Firmas/AltaNuevoExpedienteProcesado',
    BuscarProcesados: 'SIVAC/Administracion/Firmas/BuscarProcesados',
    BuscarProcesadosParaFirmar: 'SIVAC/Administracion/Firmas/BuscarProcesadosParaFirmar',
    DarDeBajaProcesadoExpediente: 'SIVAC/Administracion/Firmas/DarDeBajaProcesadoExpediente',
    EdicionProcesadoExpediente: 'SIVAC/Administracion/Firmas/EdicionProcesadoExpediente',
    ObtenerTiposDeDocumentosIdYDBId : 'SIVAC/Administracion/ObtenerTiposDeDocumentosIdYDBId',
    ReactivarProcesado: 'SIVAC/Administracion/Firmas/ReactivarProcesado',
    
}

const administracion = {
    pagos: pagos,
    firmas: firmas
}

export default administracion;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIVAC/Sistema/Administracion/administracion.js
// module id = null
// module chunks = 